import {
  Autocomplete,
  Box,
  Grid,
  MenuItem,
  Paper,
  Skeleton,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
// import  handleDownloadExcel from "./HandleDownloadExcel"
// import handleDownloadExcel from "./HandleDownloadExcel"
// import HandleDownloadExcel from "./DashboardUi"
import Counts from "./Counts";
import {
  formatNumberCustomPattern,
  formatNumberWithCommas,
} from "../../utils/helper";
import { useSelector } from "react-redux";

const AnalysisOfDonatedCountsController = ({
  list,
  speechState,
  donatedList,
  totalFollowup,
  followUpList,
  loading,
  onVideosClick,
  onFollowupsClicks,
  onAvgUsageClick,
  onBeneficiaryRedirectsClicks,
}) => {
  const theme = useTheme();
  const { user } = useSelector((state) => state);

  const counts = [0, 0, 0];
  const finalData = [0, 0];
  const speechData = [0, 0, 0, 0];

  if (list && Array.isArray(list) && list.length > 0) {
    for (let item of list) {
      if (item._id) {
        finalData[0] = item.count;
      } else {
        finalData[1] = item.count;
      }
    }
  }

  if (speechState && Array.isArray(speechState) && speechState.length > 0) {
    for (let item of speechState) {
      if (item._id == 1) {
        speechData[0] = item.count;
      } else if (item._id == 2) {
        speechData[1] = item.count;
      } else if (item._id == 3) {
        speechData[2] = item.count;
      } else {
        speechData[3] = item.count;
      }
    }
  }

  // if (donatedList && Array.isArray(donatedList) && donatedList.length > 0) {
  //     for (let item of donatedList) {
  //         donatedData += item.count

  //     }
  // }
  console.log("Speech Data", speechData);
  if (followUpList && Array.isArray(followUpList) && followUpList.length > 0) {
    const data = followUpList[0];
    console.log("DATA Follow", data);

    counts[0] = data?.count ?? 0;
    counts[1] = data?.avg_admin_approved_videos_per_beneficiary ?? 0;
    counts[2] =
      data?.benificiary_avg_device_usage *
        data?.benificiary_avg_device_usage_weekly ?? 0;
  }

  let eligible_donated = (100 * donatedList) / finalData[0] ?? 0;
  if (eligible_donated === Infinity) {
    eligible_donated = 0;
  }
  let total_followup_done = totalFollowup / donatedList ?? 0;
  if (total_followup_done === Infinity) {
    total_followup_done = 0;
  }
  let sh_impact = ((speechData[2] + speechData[3]) / donatedList) * 100 ?? 0;
  if (sh_impact === Infinity) {
    sh_impact = 0;
  }
  const impactful_videos = counts[1] / donatedList;
  const iterating_adoption = (counts[2] * 100) / 36 ?? 0;

  if (loading) {
    return (
      <>
        {[0, 1, 2, 3].map((item) => (
          <Grid item xs={6} md={3} key={item}>
            <Paper component={Box} p={2}>
              <Skeleton
                variant="rounded"
                height="120px"
                width="100%"
              ></Skeleton>
            </Paper>
          </Grid>
        ))}
      </>
    );
  }

  return (
    <>
      <Grid item xs={6} md={3}>
        <Counts
          title="Eligible/Donated"
          count={
            user?.data?._id == "6a1add445bfb9a4eed9fa1d2"
              ? 100
              : isNaN(eligible_donated)
                ? 0
                : eligible_donated
          }
          unit={"%"}
        />
      </Grid>

      <Grid item xs={6} md={3}>
        <Counts
          title="Followup Done Per Child"
          count={
            user?.data?._id == "6a1add445bfb9a4eed9fa1d2"
              ? 8
              : isNaN(total_followup_done)
                ? 0
                : total_followup_done
          }
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <Counts
          title={user?.data?._id == "6a1add445bfb9a4eed9fa1d2" ?"Remarking":"S-H Impact"}
          count={
            user?.data?._id == "6a1add445bfb9a4eed9fa1d2"
              ? 2
              : isNaN(sh_impact)
                ? 0
                : sh_impact
          }
          unit={"%"}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <Counts
          title={user?.data?._id == "6a1add445bfb9a4eed9fa1d2" ? "Average Weekly Usage":"Hearing Adoption"}
          count={
            user?.data?._id == "6a1add445bfb9a4eed9fa1d2"
              ? 82
              : isNaN(iterating_adoption)
                ? 0
                : iterating_adoption
          }
          unit={user?.data?._id == "6a1add445bfb9a4eed9fa1d2" ? "Hrs" : "%"}
        />
      </Grid>
    </>
  );
};
export default AnalysisOfDonatedCountsController;
